import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickSingleQuery } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient } from "../../clients";

import type { IMemberPapers } from "@api/members/papers/routeType";

const { key, getPath } = getApi("members.papers.get");

type IExtractedRouteType = IMemberPapers["paperSingleRetrieve"];

export type IGetMemberPaper = IPickSingleQuery<IExtractedRouteType>;

const getMemberPaper: Fetcher<
  IGetMemberPaper["response"],
  IGetMemberPaper["variables"]
> = ({ memberId, paperId, ...params }) => {
  return axiosClient.get(getPath({ memberId, paperId }), { params });
};

export const useGetMemberPaper = createQuery({
  queryKey: [key],
  fetcher: getMemberPaper,
});
